<div class="relative flex flex-1 flex-col {{ bgClasses || 'bg-container' }}">
  @let _toolbar = toolbar();

  @if (_toolbar) {
    @let _integrations = toolbarIntegrations();

    <snoots-page-generic-toolbar
      [items]="_toolbar.items()"
      [customClass]="_toolbar.customClass()"
      [alignItems]="_toolbar.alignItems()"
      [toolbarIntegrations]="_integrations"
      [integrationParamsBuilder]="integrationParamsBuilder()"
    ></snoots-page-generic-toolbar>
  }

  @if (
    (!!customItems && customItems.length > 0) ||
    (!!primaryActions && primaryActions.length > 0)
  ) {
    <div class="flex flex-row gap-4 px-2 py-2">
      @if (!!primaryActions && primaryActions.length > 0) {
        <div class="flex flex-row gap-2">
          @for (action of defaultActions; track $index) {
            <snt-button-icon
              [icon]="action.icon"
              [title]="action.title"
              [disabled]="action.disabled"
              (onClick)="action.onClick?.emit()"
              (onClickAsync)="action.onClickAsync?.emit($event)"
            ></snt-button-icon>
          }

          @for (action of primaryActions; track $index) {
            @if (isAction(action)) {
              <ng-container
                [ngTemplateOutlet]="actionTemplate"
                [ngTemplateOutletContext]="{ $implicit: action }"
              ></ng-container>
            }

            @if (isSeparator(action)) {
              <div class="flex items-center px-2">
                <i class="fa-light fa-pipe"></i>
              </div>
            }
          }
        </div>
      }

      @if (
        !!customItems &&
        customItems.length > 0 &&
        !!primaryActions &&
        primaryActions.length > 0
      ) {
        <div class="w-px self-stretch bg-slate-200"></div>
      }

      @if (customItemsStart && customItemsStart.length > 0) {
        <div class="flex flex-row gap-2">
          @for (customItem of customItemsStart; track $index) {
            <ng-container
              [ngTemplateOutlet]="customItem.templateRef"
            ></ng-container>
          }
        </div>
      }

      @if (customItemsEnd && customItemsEnd.length > 0) {
        <div class="ml-auto flex flex-row gap-2">
          @for (customItem of customItemsEnd; track $index) {
            <ng-container
              [ngTemplateOutlet]="customItem.templateRef"
            ></ng-container>
          }
        </div>
      }
    </div>

    <div class="h-px bg-slate-100"></div>
  }

  <div class="flex flex-1 flex-col">
    @if (search) {
      <div class="flex items-center justify-center p-4">
        <snt-text-box
          [placeholder]="search.placeholder"
          [debounceTime]="search.debounceTime"
          (value)="search.search.emit($event)"
          (startTyping)="search.startTyping.emit()"
          (endTyping)="search.endTyping.emit()"
          class="w-96"
        ></snt-text-box>
      </div>
    }

    <div
      [ngClass]="{
        relative: PLATFORM === PlatformType.DESKTOP,
        flex: PLATFORM === PlatformType.MOBILE
      }"
      class="flex-1"
    >
      <div
        [ngClass]="{
          'p-2': !noPadding,
          'absolute inset-0':
            !disableAbsolute() && PLATFORM === PlatformType.DESKTOP,
          'flex-1': PLATFORM === PlatformType.MOBILE
        }"
        class="flex"
      >
        <div
          class="flex-1"
          [ngClass]="{
            flex: layout === 'default',
            'grid grid-cols-12': layout === 'center'
          }"
        >
          <div
            class="flex"
            [ngClass]="{
              'rounded-md bg-container': !noBackground(),
              'm-2': !noMargin(),
              'flex-1': layout === 'default',
              'col-span-8 col-start-3': layout === 'center'
            }"
          >
            <ng-content></ng-content>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #actionTemplate let-action>
  <snt-button-icon
    [icon]="action.icon"
    [title]="action.title"
    [disabled]="action.disabled"
    [type]="'primary'"
    (onClick)="action.onClick.emit()"
    (onClickAsync)="action.onClickAsync.emit($event)"
  ></snt-button-icon>
</ng-template>
